<template>
  <el-drawer :visible.sync="visible" destroy-on-close size="50%" title="Información del reparto">
    <div v-if="deliveryInfo" class="drawer-content">
      <el-descriptions :column="1" :labelStyle="{ fontWeight: 'bold' }" title="Reparto">
        <el-descriptions-item label="Referencia de zona">
          {{ deliveryInfo.zoneRef }}
        </el-descriptions-item>
        <el-descriptions-item label="Nombre de zona">
          {{ deliveryInfo.zoneName }}
        </el-descriptions-item>
        <el-descriptions-item label="Reparto">
          {{ deliveryInfo.nameDelivery }}
        </el-descriptions-item>
        <el-descriptions-item label="Cadena de reparto">
          {{ deliveryInfo.deliveryText }}
        </el-descriptions-item>
      </el-descriptions>
      <el-descriptions
        :column="1"
        :labelStyle="{ fontWeight: 'bold' }"
        class="mt-3"
        title="Portal"
      ></el-descriptions>
      <markers-polylines-map
        :center="portalCoords"
        :markers="markers"
        :polylines="polylines"
        :zoom="20"
        height="calc(100vh - 298px)"
      />
    </div>
  </el-drawer>
</template>

<script>
import drawer from "@/mixins/drawer";
import MarkersPolylinesMap from "@/components/MarkersPolylinesMap";
import { equals } from "@/utils/arrays";

export default {
  name: "DeliveryInfoModalDrawer",

  components: {
    MarkersPolylinesMap,
  },

  mixins: [drawer],

  props: {
    deliveryInfo: Object,
    streetFrom: Object,
    streetTo: Object,
  },

  computed: {
    markers() {
      const selectedPortalCoords = [...this.deliveryInfo.coords].reverse();
      return [
        ...this.getStreetMarkers(this.streetTo, "orange"),
        ...this.getStreetMarkers(this.streetFrom, "blue"),
      ]
        .map((p) => {
          if (equals(p.coords, selectedPortalCoords)) {
            return {
              ...p,
              color: "green",
            };
          }
          return p;
        })
        .sort((a, b) => (a.color === "green" ? -1 : b.color === "green" ? 1 : 0));
    },
    polylines() {
      return [];
    },
    portalCoords() {
      return [...this.deliveryInfo.coords].reverse();
    },
  },

  methods: {
    getStreetMarkers(street, color) {
      if (!street) return [];
      return street.portals
        .map((s) => ({
          ...s,
          coords: [...s.coords].reverse(),
        }))
        .map((p) => ({
          coords: p.coords,
          label: `${p.number}${p.letter ? "-" + p.letter : ""}`,
          color,
        }));
    },
    getStreetPolyline(street) {
      if (!street) return [];
      return street.portals.map((s) => [...s.coords].reverse());
    },
  },
};
</script>
